import { wrapTextChildrenWithTypography } from '@/helpers/typography-wrapper';
import * as NavigationMenu from '@radix-ui/react-navigation-menu';
import { tk } from '@sunwebgroup/ui-components';
import { styled } from 'styled-components';

export const MenuTrigger = styled(NavigationMenu.Trigger).attrs(({ children }) => ({
  children: wrapTextChildrenWithTypography(children),
}))`
  align-items: center;
  border-radius: ${tk('radius_rounded')};
  display: inline-flex;
  justify-content: space-between;

  &[data-state] + div {
    display: none;
  }
`;
